export default __webpack_public_path__ + "static/media/UserIconActive.0e4901f7.svg";